import { timeline } from "../../../mocks/gossip";

export default function Timeline() {
  return (
    <section id="timeline" className="bg-[#2a2320]">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <p className="inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-[#e0a66a]">
            <span className="h-px w-6 bg-[#e0a66a]"></span>时间脉络
          </p>
          <h2 className="mt-3 font-serif-sc text-3xl font-black text-[#f7e4d6] md:text-4xl">
            热度有起伏，脉络有章法
          </h2>
          <p className="mt-4 leading-relaxed text-[#cfc2b2]">
            事件并非一蹴而就，而是沿着一套可复现的节奏推进。看懂五个阶段，就能预判下一轮讨论会从哪里再次升温。
          </p>
        </div>

        <ol className="mt-12 grid gap-6 md:grid-cols-5">
          {timeline.map((t, i) => (
            <li key={t.title} className="relative rounded-lg border border-[#4a413a] bg-[#332c26] p-5">
              {i < timeline.length - 1 && (
                <span className="absolute -right-4 top-1/2 hidden -translate-y-1/2 text-[#6a5f54] md:block">
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              )}
              <span className="font-serif-sc text-2xl font-black text-[#e0a66a]">{t.marker}</span>
              <span className="mt-1 block text-xs tracking-widest text-[#8a7c6c]">{t.phase}</span>
              <h3 className="mt-2 font-serif-sc text-lg font-bold text-[#f7e4d6]">{t.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#b8aa98]">{t.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}